import * as React from 'react';
import { cva } from 'class-variance-authority';

import { cn } from '../../lib/cn';

// Filters, panel tabs and top-level nav. `accent` is the in-panel teal tint; `nav`
// is the solid white capsule used for section tabs.
export const pillVariants = cva(
  'inline-flex items-center justify-center gap-1.5 rounded-[40px] font-dusq font-bold whitespace-nowrap focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-dusq-accent',
  {
    variants: {
      variant: { accent: '', nav: '' },
      selected: { true: '', false: '' },
      size: {
        default: 'px-2.5 py-2 text-[11px]',
        small: 'px-2 py-1 text-[10px]',
        nav: 'px-2.5 py-2 text-[14px] font-medium',
      },
    },
    compoundVariants: [
      { variant: 'accent', selected: true, class: 'bg-dusq-accent-soft text-dusq-accent' },
      {
        variant: 'accent',
        selected: false,
        class: 'bg-dusq-raised text-dusq-grey400 hover:text-dusq-text',
      },
      {
        variant: 'nav',
        selected: true,
        class: 'bg-dusq-emphasis-high text-dusq-emphasis-high-dark',
      },
      {
        variant: 'nav',
        selected: false,
        class: 'bg-dusq-grey950 text-dusq-grey400 hover:text-dusq-text',
      },
    ],
    defaultVariants: { variant: 'accent', selected: false, size: 'default' },
  }
);

export const Pill = React.forwardRef(
  ({ className, variant, selected, size, as, ...props }, ref) => {
    const Comp = as || 'button';
    return (
      <Comp
        ref={ref}
        type={Comp === 'button' ? 'button' : undefined}
        className={cn(pillVariants({ variant, selected, size }), className)}
        {...props}
      />
    );
  }
);
Pill.displayName = 'Pill';
